import { Component, OnInit, inject } from '@angular/core';
import { BrandingService } from '@approot/branding';
import { StartupApiCallsService } from '@approot/services/startup-api-calls.service';
import { isFeatureEnabled } from '@approot/utilities';

@Component({
  selector: 'app-app-wrapper',
  templateUrl: './app-wrapper.component.html',
  styleUrls: ['./app-wrapper.component.scss']
})
export class AppWrapperComponent implements OnInit {
  private startupApiCallsService = inject(StartupApiCallsService);
  public brand = inject(BrandingService);
  public startupState = this.startupApiCallsService.startupState;
  public enableStartupLogging = isFeatureEnabled('enableStartupLogging', false);

  public ngOnInit(): void {
    this.startupApiCallsService.startupCalls();
  }
}
